import { Injectable } from '@angular/core';

@Injectable()
export class IconConfig {
  // No config required yet
}